import type {
  WorkspaceBillingActivityPageContract,
  WorkspaceBillingActivityType,
  WorkspaceBillingContract,
} from '@nest-react/domain';

export type WorkspaceBillingActivitySnapshot = {
  page: WorkspaceBillingActivityPageContract | null;
  loading: boolean;
  error: string | null;
  type: WorkspaceBillingActivityType | null;
  cursor: string | null;
};

export const emptyBillingActivitySnapshot =
  (): WorkspaceBillingActivitySnapshot => ({
    page: null,
    loading: false,
    error: null,
    type: null,
    cursor: null,
  });

export type WorkspaceBillingSnapshot = {
  balance: string | null;
  walletLoading: boolean;
  walletLoaded: boolean;
  summary: WorkspaceBillingContract | null;
  summaryLoading: boolean;
  summaryError: string | null;
  summaryLoaded: boolean;
  activity: WorkspaceBillingActivitySnapshot;
};

export const emptyBillingSnapshot = (): WorkspaceBillingSnapshot => ({
  balance: null,
  walletLoading: false,
  walletLoaded: false,
  summary: null,
  summaryLoading: false,
  summaryError: null,
  summaryLoaded: false,
  activity: emptyBillingActivitySnapshot(),
});

export const billingActivityRequestKey = (
  type: WorkspaceBillingActivityType | null,
  cursor: string | null
): string => `${type ?? 'all'}:${cursor ?? 'start'}`;
